import { AutogenModelFixedTimeCall, AutogenRowFixedTimeCall } from "./autogen/AutogenModelFixedTimeCall";

export class ModelFixedTimeCall extends AutogenModelFixedTimeCall<RowFixedTimeCall> {
	constructor() {
		super(RowFixedTimeCall);
	}
}

export class RowFixedTimeCall extends AutogenRowFixedTimeCall {
}